import { render, staticRenderFns } from "./layout-cart-products.vue?vue&type=template&id=5988e1a8&scoped=true&"
import script from "./layout-cart-products.vue?vue&type=script&lang=js&"
export * from "./layout-cart-products.vue?vue&type=script&lang=js&"
import style0 from "./layout-cart-products.vue?vue&type=style&index=0&id=5988e1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988e1a8",
  null
  
)

export default component.exports